import React from 'react';

const CartNumberTracking = ({
  totalItems
}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "shoppingCartProductNumber",
    style: { display: "none" }
  }, totalItems);
};

export { CartNumberTracking };
